<template>
  <div id="eventsList" class="searchresult table-responsive">
    <div v-if="loading" class="message--info">
      <p>Die Daten werden aktuell geladen. Einen Moment Geduld bitte</p>
      <svg class="spinner-land" viewBox="0 0 50 50">
        <circle class="stroke"></circle>
      </svg>
    </div>
    <template v-else>
      <template  v-if="events.length > 0">
        <nav class="pagination" aria-label="Seite wechseln" v-if="eventsPages > 1">
          <ul>
              <li :aria-disabled="currentEventPage == 1" :class="{disabled: currentEventPage == 1}" class="pager-item-previous">
                <a @keyup.enter="setCurrentPage(currentEventPage-1)" @click="setCurrentPage(currentEventPage-1)" v-if="currentEventPage != 1" title="Seite zurück blättern"  role="button" tabindex="0"><i class="fas fa-chevron-left" aria-hidden="true"></i></a>
                <div v-else><i class="fas fa-chevron-left" aria-hidden="true"></i> <span class="aural">Seite zurück</span></div>
              </li>
              </li>
              <li :rel="(p == eventsPages ? 'last' : '')" :class="{active: currentEventPage == p }" :aria-current="currentEventPage == p ? 'page': ''" v-for="p in eventsPages">
                <a @keyup.enter="setCurrentPage(p)" @click="setCurrentPage(p)"  role="button" tabindex="0">{{ p }}</a>
              </li>
              <li class="mobile-counter"><span>{{ currentEventPage }} / {{ eventsPages }}</span></li>
              <li class="pager-item-next"  :aria-disabled="currentEventPage == eventsPages" :class="{disabled: currentEventPage == eventsPages}">
                <a @keyup.enter="setCurrentPage(currentEventPage+1)" @click="setCurrentPage(currentEventPage+1)" v-if="currentEventPage != eventsPages" title="Seite weiter blättern"  role="button" tabindex="0"><i class="fas fa-chevron-right" aria-hidden="true"></i></a>
                <div v-else><i class="fas fa-chevron-right" aria-hidden="true"></i> <span class="aural">Seite weiter</span></div>
              </li>
          </ul>
        </nav>

        <table class="result table bordered-table zebra-striped">
          <thead>
            <tr>
              <th class="longtext" id="Angebot">Angebot</th>
              <th class="text" id="Details">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(e,i) in paginatedEvents" :class="{odd: (i%2 != 0), even: (i%2 == 0)}">
              <td class="longtext" headers="Angebot">
                <strong>
                  <a :href="`/angebote/${e.permalink}`" title="Zur Detailseite">
                  {{ e.title }}
                  </a>
                </strong>
                <div v-if="e.isCanceled" class="pill pill--error pill--inverted">
                  Abgesagt
                </div>
              </td>
              <td class="text" headers="Details">
                <div class="textile">
                  <p>
                    <ul>
                      <li><span class="title-meta category-name"><strong>Kategorie:</strong> {{ e.categoryName}}</span></li>
                      <li><span class="title-meta club-name"><strong>Verein/Träger:</strong> {{ e.club }}</span></li>
                    </ul>
                  </p>
                  <p>
                    {{ e.park }}<br>
                    {{ e.street }}
                  </p>

                  <strong>Termine</strong>
                  <ul>
                    <template v-for="dname in Object.keys(days)">
                      <li v-if="e.wdayData[`enabled_${days[dname]}`] == 1">
                        <strong>{{ dname}}:</strong>
                        <span>{{ e.wdayData[`start_time_${days[dname]}`] }} - {{ e.wdayData[`end_time_${days[dname]}`] }} Uhr</span>
                      </li>
                    </template>
                  </ul>

                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <nav class="pagination" aria-label="Seite wechseln" v-if="eventsPages > 1">
          <ul>
              <li :aria-disabled="currentEventPage == 1" :class="{disabled: currentEventPage == 1}" class="pager-item-previous">
                <a @keyup.enter="setCurrentPage(currentEventPage-1)" @click="setCurrentPage(currentEventPage-1)" v-if="currentEventPage != 1" title="Seite zurück blättern" role="button" tabindex="0"><i class="fas fa-chevron-left" aria-hidden="true"></i></a>
                <div v-else><i class="fas fa-chevron-left" aria-hidden="true"></i> <span class="aural">Seite zurück</span></div>
              </li>
              </li>
              <li :rel="(p == eventsPages ? 'last' : '')" :class="{active: currentEventPage == p }" :aria-current="currentEventPage == p ? 'page': ''" v-for="p in eventsPages">
                <a @keyup.enter="setCurrentPage(currentEventPage)" @click="setCurrentPage(p)"  role="button" tabindex="0">{{ p }}</a>
              </li>
              <li class="mobile-counter"><span>{{ currentEventPage }} / {{ eventsPages }}</span></li>
              <li class="pager-item-next"  :aria-disabled="currentEventPage == eventsPages" :class="{disabled: currentEventPage == eventsPages}">
                <a @keyup.enter="setCurrentPage(currentEventPage+1)" @click="setCurrentPage(currentEventPage+1)" v-if="currentEventPage != eventsPages" title="Seite weiter blättern" role="button" tabindex="0"><i class="fas fa-chevron-right" aria-hidden="true" ></i></a>
                <div v-else><i class="fas fa-chevron-right" aria-hidden="true"></i> <span class="aural">Seite weiter</span></div>
              </li>
          </ul>
        </nav>
      </template>

      <div class="message--error" v-else-if="context != 'similar'">
        <h2 class="title">Keine Ergebnisse gefunden</h2>
        <p>Für dieses Datum oder Ihre aktuellen Filterkriterien haben wir derzeit leider kein Angebot</p>
      </div>
    </template>
  </div>

</template>

<script>

export default {
  props: {
    events: {
      type: Array,
      default: () => { return [] }
    },
    date: {
      type: Date,
    },
    context: {
      type: String,
      default: 'calendar'
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      days: {'Montag': 1, 'Dienstag': 2, 'Mittwoch': 3, 'Donnerstag': 4, 'Freitag': 5, 'Samstag': 6, 'Sonntag': 0 },
      eventsCount: 20,
      currentEventPage: 1
    }
  },
  methods: {
    setCurrentPage(p){
      this.currentEventPage = p
      var ofs = document.getElementById('currentEvents').offsetTop
      window.scrollTo(0,ofs);
    }
  },
  computed: {
    eventsPages(){
      return Math.ceil(this.events.length/this.eventsCount)
    },
    paginatedEvents(){
      let from = (this.currentEventPage - 1) * this.eventsCount
      let to = from + this.eventsCount
      return this.events.slice(from, to)
    }
  }
}

</script>
